import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const WorkspaceContext = createContext(null);
const ACTIVE_KEY = "carrot_active_workspace";

export function WorkspaceProvider({ children }) {
  const [workspaces, setWorkspaces] = useState([]);
  const [activeId, setActiveIdState] = useState(() => localStorage.getItem(ACTIVE_KEY) || null);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/workspaces");
      setWorkspaces(r.data);
      setActiveIdState((cur) => (cur && !r.data.some((w) => w.id === cur) ? null : cur));
    } catch { /* noop */ }
    finally { setLoaded(true); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const setActiveId = useCallback((id) => {
    setActiveIdState(id);
    if (id) localStorage.setItem(ACTIVE_KEY, id);
    else localStorage.removeItem(ACTIVE_KEY);
  }, []);

  const activeWorkspace = workspaces.find((w) => w.id === activeId) || null;

  return (
    <WorkspaceContext.Provider value={{ workspaces, activeId, activeWorkspace, setActiveId, refresh, loaded }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export const useWorkspace = () => useContext(WorkspaceContext);
